import React, { Component } from 'react';
import { Row, Radio, Icon, Spin } from 'antd';
import CatalogosRequest from '../../services/Catalogos';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import ResponsiveCard from '../Common/ResponsiveCard';

/**
 * Clase para ver el proceso de mostrar productos
 */
export default class ModeloProductos extends Component {
    state = {
        arrTiposModelo: [],
        arrCategorias: [],
        modeloSelected: null,
        categoriaSelected: null,
        modeloSelectedName: null,
        categoriaSelectedName: null,
        disableBtnContinuar: true,
        cargando: false,
    }

    /**
     * Función que se ejecuta cuando se cargan los datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        this.setState({ cargando: true }, () => {
            CatalogosRequest.ListarTiposModelos()
                .then(response => {
                    state.arrTiposModelo = response.data
                    state.cargando = false
                    this.setState(state)
                })
                .catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los tipos de modelos.",
                        "Error al cargar tipos de modelo",
                        false
                    )
                })
        })
    }

    /**
     * Función que se cambia el modelo
     * @param: value. valor del id del modelo
     * @return: nada.
     */
    onChangeModelo = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = null
        state.categoriaSelectedId = null
        state.disableBtnContinuar = true
        state.modeloSelected = value.target.value
        state.cargando = true
        for (let index = 0; index < state.arrTiposModelo.length; index++) {
            const element = state.arrTiposModelo[index];
            if (value.target.value === element.id) state.modeloSelectedName = element.descripcion
        }
        this.setState(state, () => {
            CategoriasRequest.ListarCategoriasModelo(state.modeloSelected)
                .then(response => {
                    state.arrCategorias = response.data
                    state.cargando = false
                    this.setState(state)
                })
                .catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar las categorías.",
                        "Error al cargar categorías",
                        false
                    )
                })
        })
    }

    /**
     * Función que se cambia la categoría
     * @param: value. valor del id de la categoría
     * @return: nada.
     */
    onChangeCategoria = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = value.target.value
        state.categoriaSelectedId = value.target.value
        state.disableBtnContinuar = false
        for (let index = 0; index < state.arrCategorias.length; index++) {
            const element = state.arrCategorias[index];
            if (value.target.value === element.id) state.categoriaSelectedName = element.descripcion
        }

        let categoriaSelected = state.categoriaSelectedName
        let categoriaSelectedId = state.categoriaSelected
        let modeloSelected = state.modeloSelectedName
        let modeloSelectedId = state.modeloSelected
        this.props.history.push(
            {
                pathname: `/productos_${modeloSelected.toLowerCase().replace('\n', '')}`,
                state: {
                    categoria_id: categoriaSelectedId,
                    categoria: categoriaSelected,
                    modelo_id: modeloSelectedId,
                    modelo: modeloSelected
                }
            }
        )
        this.setState(state)
    }

    render() {
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo productos"
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        >
                            <Row>
                                <span style={{ fontSize: '20px', marginLeft: '30px' }}>Seleccione tipo de modelo</span>
                            </Row> <br />
                            <Row gutter={24}>
                                <Radio.Group
                                    onChange={this.onChangeModelo}
                                    buttonStyle="solid">
                                    {
                                        this.state.arrTiposModelo.length > 0 &&
                                        this.state.arrTiposModelo.map(obj => {
                                            return (
                                                <Radio.Button
                                                    className="radio-button"
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.descripcion}
                                                </Radio.Button>
                                            )
                                        })
                                    }
                                </Radio.Group>
                            </Row> <br />
                            <Row className={this.state.modeloSelected === null ? 'display-none' : ''}>
                                <span style={{ fontSize: '20px', marginLeft: '30px' }}>Seleccione categoría</span>
                            </Row> <br />
                            <Row className={this.state.modeloSelected === null ? 'display-none' : ''} gutter={24}>
                                <Radio.Group
                                    onChange={this.onChangeCategoria}
                                    buttonStyle="solid"
                                    value={this.state.categoriaSelectedId}
                                >
                                    {
                                        this.state.arrCategorias.length > 0 &&
                                        this.state.arrCategorias.map(obj => {
                                            return (
                                                <Radio.Button
                                                    className="radio-button"
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.descripcion}
                                                </Radio.Button>
                                            )
                                        })
                                    }
                                </Radio.Group>
                            </Row>
                        </Spin>
                    </div>
                </div>
            </ResponsiveCard>
        )
    }
}